export default "__VITE_ASSET__af4075d5__"